








































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import legislationModule from '@/store/Legislation';
import snackModule from '@/store/Snack';

import AllergenListItem from '@/components/common/AllergenListItem.vue';
import {
  DispersionType,
  DispersionTypeItems,
  IngredientCrosscontact,
  Allergen,
  Ingredient,
  Legislation,
} from '@/api';

@Component({
  components: {
    AllergenListItem,
  },
})
export default class AllergenList extends Vue {
  @Prop({ required: true }) readonly legislationId: string;

  @Prop({ required: true }) readonly item: Ingredient;

  @Prop({ default: false, type: Boolean }) readonly readonly: boolean;

  crosscontacts: IngredientCrosscontact[] = [];

  dialog = false;

  crosscontact: IngredientCrosscontact | null = null;

  legislation = new Legislation();

  ingredient = new Ingredient(); // tmp value

  ingredientOriginal = new Ingredient();

  valid = false;

  isDirty = false;

  loading = false;

  get sortedAllergens() {
    return this.legislation.sortedAllergens;
  }

  allergenById(id: string) {
    return this.legislation.allergens.find(allergen => allergen.id === id);
  }

  get DispersionType() {
    return DispersionType;
  }

  get dispersionTypeItems() {
    return DispersionTypeItems;
  }

  get validation() {
    return this.crosscontacts.length ? 'complete' : 'incomplete';
  }

  cancel() {
    this.ingredient = this.ingredientOriginal.dup();
  }

  editCrosscontact(
    allergen: Allergen,
    crosscontact: IngredientCrosscontact | null,
  ) {
    this.crosscontact = crosscontact
      ? crosscontact.dup()
      : new IngredientCrosscontact({
          allergen,
          ingredient: this.ingredient,
          dispersionType: DispersionType.Intentional,
          concentration: 0,
        });
    this.dialog = true;
  }

  async saveCrosscontact() {
    if (!this.crosscontact) {
      throw new Error(
        this.$t('allergens.alerts.missingCrosscontact') as string,
      );
    }
    if (this.loading) {
      return;
    }
    try {
      this.loading = true;
      await this.crosscontact.save({ with: ['allergen.id', 'ingredient.id'] });
      snackModule.setSuccess(
        this.$t('allergens.alerts.allergenSaved') as string,
      );
      await this.update();
      this.dialog = false;
    } catch (e) {
      snackModule.setError({
        text: this.$t('allergens.alerts.allergenNotSaved') as string,
        errors: e.response.errors,
      });
    } finally {
      this.loading = false;
    }
  }

  async deleteCrosscontact() {
    if (!this.crosscontact) {
      throw new Error(
        this.$t('allergens.alerts.missingCrosscontact') as string,
      );
    }
    if (this.loading) {
      return;
    }
    try {
      this.loading = true;
      if (this.crosscontact.isPersisted) {
        await this.crosscontact.destroy();
      }
      snackModule.setSuccess(
        this.$t('allergens.alerts.allergenRemoved') as string,
      );
      await this.update();
      this.dialog = false;
    } catch (e) {
      snackModule.setError({
        text: this.$t('allergens.alerts.allergenNotRemoved') as string,
        errors: e.response.errors,
      });
    } finally {
      this.loading = false;
    }
  }

  async update() {
    this.legislation = await legislationModule.getLegislation(
      this.legislationId,
    );
    this.crosscontacts = (
      await IngredientCrosscontact.where({
        ingredient: this.ingredient.id,
      }).all()
    ).data;
  }

  @Watch('item', { immediate: true })
  async itemChanged() {
    this.ingredient = this.item.dup();
    this.ingredientOriginal = this.item.dup();
    await this.update();
  }

  @Watch('validation', { immediate: true })
  validChanged() {
    this.$emit('validation', this.validation);
  }
}
